/**
 * toolRegistry.js — Mock tool registry.
 *
 * These are DECLARATIVE descriptions — no code is executed from here.
 * Execution happens in the real navigation layer (React Router nav),
 * gated by the execution policy and user confirmation.
 *
 * To add a new tool: add an entry here + update SIGNAL_TOOL_MAP
 * in resolveToolIntent.js + add a policy entry in executionPolicy.js.
 */

import { TOOL_RISK } from "./toolContracts";

export const TOOL_REGISTRY = {
  open_family: {
    id:                   "open_family",
    label:                "Abrir familias",
    description:          "Navegar al módulo de familias del distrito",
    allowedRoles:         ["*"],
    requiresConfirmation: false,
    riskLevel:            TOOL_RISK.LOW,
    supportedModes:       ["PASTORAL_CARE", "FOLLOW_UP", "DISTRICT_OVERSIGHT"],
    offlineCompatible:    true,
    target:               "/families",
  },
  open_visits: {
    id:                   "open_visits",
    label:                "Abrir visitas",
    description:          "Navegar al módulo de visitas pastorales",
    allowedRoles:         ["*"],
    requiresConfirmation: false,
    riskLevel:            TOOL_RISK.LOW,
    supportedModes:       ["PASTORAL_CARE", "FOLLOW_UP", "DISTRICT_OVERSIGHT"],
    offlineCompatible:    true,
    target:               "/visits",
  },
  create_visit: {
    id:                   "create_visit",
    label:                "Registrar visita",
    description:          "Iniciar el formulario para una nueva visita pastoral",
    allowedRoles:         ["pastor", "coordinator", "admin"],
    requiresConfirmation: true,
    riskLevel:            TOOL_RISK.MEDIUM,
    supportedModes:       ["PASTORAL_CARE", "FOLLOW_UP"],
    offlineCompatible:    true,
    target:               "/visits/new",
  },
  open_audit: {
    id:                   "open_audit",
    label:                "Abrir auditoría",
    description:          "Navegar al registro de auditoría del sistema",
    allowedRoles:         ["admin"],
    requiresConfirmation: false,
    riskLevel:            TOOL_RISK.LOW,
    supportedModes:       ["ADMIN_REVIEW"],
    offlineCompatible:    false,
    target:               "/admin/audit",
  },
  open_prayer: {
    id:                   "open_prayer",
    label:                "Abrir oraciones",
    description:          "Navegar al módulo de oración e intercesión",
    allowedRoles:         ["*"],
    requiresConfirmation: false,
    riskLevel:            TOOL_RISK.LOW,
    supportedModes:       ["PASTORAL_CARE"],
    offlineCompatible:    true,
    target:               "/prayers",
  },
};

export function getToolById(id) {
  return TOOL_REGISTRY[id] ?? null;
}

export function getAllTools() {
  return Object.values(TOOL_REGISTRY);
}
